import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Spin } from 'antd';

const Wrapper = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    overflow: hidden;
`;

const Footer = styled.div`
    overflow: hidden;
`;

const Content = styled.div`
    flex: 1;
    overflow: auto;
    position: relative;
    .block-content-wrapper {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: row;
    }

    .block-content {
        flex: 1;
        height: 100%;
        /* Claude Code: min-width:0 lets this flex item shrink to the available
           space instead of growing to its content's intrinsic width, which
           otherwise pushes the layout past 100% and causes horizontal scroll */
        min-width: 0;
    }
`;

const LoadingOverlay = styled.div`
    display: ${props => (props.visible ? '' : 'none')};
    flex: 1;
    height: 100%;
    position: absolute;
    width: 100%;
    background: #fff;
    opacity: 0.6;
    z-index: 999;
    .block-overlay-spinner {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
`;

class Block extends React.Component {
    static propTypes = {
        header: PropTypes.element,
        footer: PropTypes.element,
        leftPanel: PropTypes.element,
        rightPanel: PropTypes.element,
        padding: PropTypes.number,
        scrollingRef: PropTypes.func
    };

    static defaultProps = {
        scrollingRef: null,
        loading: false,
        padding: 0
    };

    render() {
        const { props } = this;
        const { padding, className, scrollingRef } = props;

        const isPrintView = Boolean(global.Cla?.app?.router?.query?.printView);

        if (isPrintView) {
            // remove all wrapper frames
            return props.children;
        }

        return (
            <Wrapper
                className={`clad-block ${className || ''}`}
                style={{ ...props.style }}
            >
                <LoadingOverlay visible={props.loading}>
                    <Spin className="block-overlay-spinner" />
                </LoadingOverlay>
                {props.header && (
                    <Header style={{ padding: padding }}>{props.header}</Header>
                )}
                <Content className="block-content-parent">
                    <div className="block-content-wrapper">
                        {props.leftPanel && (
                            <React.Fragment>{props.leftPanel}</React.Fragment>
                        )}

                        <div
                            ref={scrollingRef}
                            style={{ padding: padding || null }}
                            className="block-content"
                        >
                            {props.children}
                        </div>

                        {props.rightPanel && (
                            <React.Fragment>{props.rightPanel}</React.Fragment>
                        )}
                    </div>
                </Content>
                {props.footer && (
                    <Footer style={{ padding: padding }}>{props.footer}</Footer>
                )}
            </Wrapper>
        );
    }
}

export default Block;
